import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../util';

// See ZEN-2057 - Media outlet is the only type needed in Check Sources and Stories.

const MediaOutletSearchResult = ({
  styles,
  mediaOutlet,
  domain,
  sourceProviders,
  isValid,
  authorGroupNames,
  isCovered,
  storyCount,
  hasGroups,
  lastCoveredAt,
}) => (
  <div className={styles.sourceCheckerSearchResult}>
    <div
      className={`${styles.sourceCheckerSearchResultIcon}
      ${styles[utils.getClassNameBasedOnCoverage(isValid, isCovered)]}`}
    >
      {utils.getIconBasedOnCoverage(isValid, isCovered)}
    </div>
    {isValid && (
      <div>
        <ul className={styles.sourceCheckerSearchResultList}>
          {isCovered && <li><b>Media outlet: </b>{mediaOutlet}</li>}
          {isCovered && domain && <li><b>Domain: </b>{domain}</li>}
          {
            isCovered && hasGroups
            && <li><b>Matching Groups: </b> {utils.getCommaSeparatedStringOrNone(authorGroupNames)}</li>
          }
          {!isCovered && <li>Could not find a domain for this media outlet</li>}
        </ul>
        <ul className={styles.sourceCheckerSearchResultList}>
          <li><b>Source provided by: </b>{utils.getCommaSeparatedStringOrNone(sourceProviders)}</li>
        </ul>
        <div
          className={styles.searchResultStats}
          dangerouslySetInnerHTML={{ __html: utils.getPrettyfiedStatistics(storyCount, lastCoveredAt) }}
        />
      </div>
    )}
  </div>
);

MediaOutletSearchResult.propTypes = {
  styles: PropTypes.object,
  mediaOutlet: PropTypes.string,
  domain: PropTypes.string,
  sourceProviders: PropTypes.arrayOf(PropTypes.string),
  isValid: PropTypes.bool,
  isCovered: PropTypes.bool,
  authorGroupNames: PropTypes.arrayOf(PropTypes.string),
  storyCount: PropTypes.number,
  hasGroups: PropTypes.bool,
  lastCoveredAt: PropTypes.string,
};

export default MediaOutletSearchResult;
